import { type FunctionComponent } from 'react';
import { Card } from '@direct-frontend/components';
import { Outlet, useLocation } from '@direct-frontend/modules-router';
import { type ErrorBoundaryRenderWrapper, ErrorBoundaryWrapper } from './ErrorBoundaryWrapper';

const renderWrapper: ErrorBoundaryRenderWrapper = (props) => (
    <Card borderRadius="14" color="white" padding="36">
        {props.children}
    </Card>
);

/**
 * Обертка для роутинга для отлова ошибок в дереве реакта
 * @kind component
 */
export const ErrorBoundaryRouterWrapper: FunctionComponent = () => {
    const location = useLocation();

    return (
        <ErrorBoundaryWrapper uniqueId={location.key} renderWrapper={renderWrapper}>
            <Outlet />
        </ErrorBoundaryWrapper>
    );
};
